<template>
  <v-card>
    <slot name="header" />
    <Loader v-if="invitationsResultsLoading" />
    <v-card-text
      v-else
      class="mt-1 d-md-flex justify-flex-start flex-wrap"
      style="gap: 12px"
    >
      <Box
        :width="$vuetify.display.mdAndDown ? '100%' : '32.5%'"
        :title="t('dashboard.details.contact-acquisition.invitation-topics.title')"
        :items="invitationTopics"
      />
      <Box
        :width="$vuetify.display.mdAndDown ? '100%' : '32.5%'"
        :title="t('dashboard.details.contact-acquisition.content-topics.title')"
        :items="topicStatistics"
      />
      <Box
        :width="$vuetify.display.mdAndDown ? '100%' : '32.5%'"
        :title="t('dashboard.details.contact-acquisition.content-types.title')"
        :items="textKindStatistics"
      />
    </v-card-text>
    <slot name="footer" />
  </v-card>
</template>

<script setup lang="ts">
import { useQuery } from '@vue/apollo-composable'
import { computed, inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import { ReadableKindType } from '@/modules/contentCreator/creator/enums/KindType'
import Box from '@/modules/dashboard/dashboardDetails/shared/box.vue'
import Loader from '@/modules/dashboard/dashboardDetails/shared/loader.vue'

import {
  DashboardContext,
  dashboardContextDefault,
  DashboardContextSymbol,
} from '../dashboardContext'
import GET_CREATED_CONTENTS_STATISTICS from './queries/GetCreatedContentsStatistics.gql'

const { t } = useI18n()

const { componentValue: invitationTopics } = defineProps<{
  componentValue: Array<{
    label: string
    value: number
  }>
}>()

const dashboardContext = inject<DashboardContext>(DashboardContextSymbol, dashboardContextDefault)

const route = useRoute()
const routeParamId = computed(() => route?.params?.id || null)
const isMasterView = computed(() => route.path.startsWith('/master'))

const variables = computed(() => ({
  input: {
    isMasterView: isMasterView.value,
    childCompanyId: routeParamId.value,
    ...dashboardContext.formattedDateFilters.value,
  },
}))

const { result: createdContentsStatistics, loading: invitationsResultsLoading } = useQuery(
  GET_CREATED_CONTENTS_STATISTICS,
  variables
)

const textKindStatistics = computed(() => {
  return createdContentsStatistics?.value?.statistics.textKindStatistics?.map((contentType) => {
    return {
      label: ReadableKindType[contentType.textKind],
      value: contentType.count,
    }
  })
})

const topicStatistics = computed(() => {
  return createdContentsStatistics?.value?.statistics.topicStatistics?.map((contentType) => {
    return {
      label: contentType.topicName,
      value: contentType.count,
    }
  })
})
</script>
